<template>
    <div class="scr-body">
        <h2 v-if="isFeedbackSent" class="text-center">Thank you for your feedback!</h2>

        <form v-if="!isFeedbackSent" @submit.prevent="submitForm" name="submit-to-google-sheet">
            <div class="form-row">
                <label>How likely are you to recommend working with DXC Technology to your coworkers, friends, or family members?</label>
                <div class="form-scale">
                    <div v-for="index in 10" :key="index" class="radio-input">
                        <input
                            :id="index"
                            type="radio"
                            :value="index"
                            v-model="satisfaction"
                            required
                        />
                        <label :for="index">{{index}}</label>
                    </div>
                </div>
                <div class="row-info">1 &ndash; Not likely, 10 &ndash; Very likely</div>
            </div>

            <div class="form-row">
                <label
                    for="materials"
                >The materials, presentations, and other resources during my visit provided all the information I needed.</label>
                <div v-for="answer in formArray" :key="`materials${answer}`" class="radio-input">
                    <input
                        :id="`materials${answer}`"
                        type="radio"
                        :name="`materials${answer}`"
                        :value="answer"
                        v-model="materials"
                    />
                    <label :for="`materials${answer}`">{{answer}}</label>
                </div>
            </div>

            <div class="form-row">
                <label for="objectives">We covered all my visit objectives during my visit.</label>
                <div v-for="answer in formArray" :key="`objectives${answer}`" class="radio-input">
                    <input
                        :id="`objectives${answer}`"
                        type="radio"
                        :name="`objectives${answer}`"
                        :value="answer"
                        v-model="objectives"
                    />
                    <label :for="`objectives${answer}`">{{answer}}</label>
                </div>
            </div>
            <div class="form-row">
                <label for="experience">How can we improve your experience during the visit?</label>
                <input
                    class="form-control"
                    id="experience"
                    placeholder="Your answer (optional)"
                    v-model="experience"
                />
            </div>
            <button class="btn" type="submit">Send</button>
        </form>
    </div>
</template>

<script>
//This component is showing the feedback form to be submitted by the visitors.
export default {
    name: "Feedback",
    data() {
        return {
            formArray: [
                "Strongly disagree",
                "Disagree",
                "Neutral",
                "Agree",
                "Strongly agree"
            ],
            satisfaction: null,
            materials: null,
            objectives: null,
            experience: "",
            isFeedbackSent: this.$store.getters.feedback
        };
    },
    created() {
        // Fired when the component is ready. <br/> Emitted for the Header to be changed to the correct title.
        // @arg The argument is a `String` value representing the current title.
        this.$emit("changed", "Feedback");
    },
    methods: {
        /**
         * @vuese
         * Used to send data to Google Form.
         * Actual data entries are captured when submitting the Google Form in a browser and seeing what the entities are called.
         */
        submitForm() {
            if (this.satisfaction && this.materials && this.objectives) {
                $.ajax({
                    url:
                        "https://docs.google.com/forms/d/1FilryHB3FPhBBLcAPA0oot0esAqmdVko-r6AcIzAsik/formResponse",
                    data: {
                        "entry.845755878": this.satisfaction,
                        "entry.692450171": this.materials,
                        "entry.485548049": this.objectives,
                        "entry.1028205780": this.experience
                    },
                    crossDomain: true,
                    type: "POST",
                    dataType: "xml",
                    success: (msg, status, jqXHR) => {}
                });
                this.isFeedbackSent = true;
                this.$store.commit("sentFeedback", true);
            }
        }
    }
};
</script>

<style>
</style>
